import * as React from 'react';
import { Controller } from "./Infraestructure/Controller";
import { ViewMain } from "./Components/View";

const ManagerEntity = () => {
    const controller = Controller();

    React.useEffect(() => {
        controller.init();
        return () => {
        }
        // eslint-disable-next-line
    }, []);

    return (<ViewMain
        salidaAlmacenAux={controller.salidaAlmacenAux}
        onChange={controller.onChange}
        formSearchAlmacen={controller.formSearchAlmacen}
        selectAlmacenUsuario={controller.selectAlmacenUsuario}
    />);
};

export default ManagerEntity;